import React from 'react';
import PropTypes from 'prop-types';

import CommonSection from '../../redesign/component/commonSection';
import { getFlowType, getAPPID, enableSelfSetup, checkIsMidnight, isWHWPhase2Flag, checkIsDisneyBundlePromo } from '../../../Helpers/index';
import { getProductRefData } from '../../../../../utils/plansReference';
import Product from '../commonComp/product';
import Tax from '../commonComp/tax';
import { Body } from '../../../Typography';
import { DISNEY_PROMO_ID, SPL_DISCOUNT_PROMO_IDS, VISION_FEATURE_CODE } from '../../Constants';

const DueMonthly = (props) => {
  const { dueMonthlyProd, planPerks, dueMontAmount, dueMonthlyList, dueMonthlyTaxes, dueMontTotalAAL, whwDueMontly, disneyPromoHelperText } = props;
  const planInfo = getProductRefData('dueMonthlyTaxForRedesign', 'dueMonthlyTaxForRedesign', props.plansReferenceData);
  const flowType = getFlowType();
  let nbsDisclaimerMonthly = '';

  const { nbsDisclaimerMonthlyLTE, nbsDisclaimerMonthly5G, nbsDisclaimerMonthlyLTEMidnight, nbsDisclaimerMonthly5GMidnight } =
    (props.plansReferenceData && props.plansReferenceData.miniCart) || {};
  if (enableSelfSetup() && getAPPID() === 'AAL') {
    if (flowType === 'LTE') {
      nbsDisclaimerMonthly = checkIsMidnight() ? nbsDisclaimerMonthlyLTEMidnight : nbsDisclaimerMonthlyLTE;
    } else {
      nbsDisclaimerMonthly = checkIsMidnight() ? nbsDisclaimerMonthly5GMidnight : nbsDisclaimerMonthly5G;
    }
  }

  const getRightValueText = () => {
    if (getAPPID() === 'AAL' && checkIsMidnight() && dueMontTotalAAL) {
      return `$${parseFloat(dueMontTotalAAL).toFixed(2)}`;
    }
    return dueMontAmount && `$${parseFloat(dueMontAmount).toFixed(2)}`;
  };

  if (!dueMonthlyProd) {
    return null;
  }

  const isPerks = checkIsMidnight() && planPerks && planPerks?.length > 0;
  const isWhwAddon = isWHWPhase2Flag() && whwDueMontly && whwDueMontly?.length > 0;

  return (
    <div className="mobiledueMonthlyWrapper  width100 pad14 onlyTopPad">
      {dueMontAmount !== null && dueMontAmount !== undefined && dueMontAmount !== '' && (
        <CommonSection id="DueMonthly Info" leftValueText="Due monthly" rightValueText={getRightValueText()} className="headerStyle" />
      )}
      <Product
        dueMonthlyList={dueMonthlyList}
        dueMonthlyAmount={dueMontAmount}
        plansReferenceData={props.plansReferenceData}
        dueMonthlyProd={dueMonthlyProd}
        disneyPromoHelperText={disneyPromoHelperText}
      />
      {isPerks &&
        planPerks?.map((item) => {
          const promoApplied = item?.discountsAndPromotions?.promos || [];
          const specialDiscountPromos = promoApplied?.filter((appliedDiscount) => SPL_DISCOUNT_PROMO_IDS.includes(appliedDiscount?.id));
          const isHavingSpecialDiscount = specialDiscountPromos?.length > 0;
          let finalPrice = 0;
          if (isHavingSpecialDiscount) {
            finalPrice = parseFloat(item?.discountsAndPromotions?.actualPrice) - parseFloat(specialDiscountPromos[0]?.amountOff);
          }
          return (
            <>
              <CommonSection
                id="Plan perks Info"
                leftValueText={item?.featureDesc}
                rightValueText={
                  <>
                    {parseFloat(item?.actualAmount)?.toFixed(2) !== parseFloat(item?.featurePrice)?.toFixed(2) && (
                      <span>
                        <span className="actualPriceStrikeThrough">${parseFloat(item?.perkOriginalPrice)?.toFixed(2)}</span>&nbsp;
                      </span>
                    )}
                    $
                    {item?.discountsAndPromotions && item?.visFeatureCode === VISION_FEATURE_CODE
                      ? isHavingSpecialDiscount
                        ? parseFloat(finalPrice)?.toFixed(2)
                        : parseFloat(item?.discountsAndPromotions?.actualPrice)?.toFixed(2)
                      : parseFloat(item?.featurePrice)?.toFixed(2)}
                  </>
                }
                className="normalStyle"
                subTitle=""
              />
              {checkIsDisneyBundlePromo() &&
                promoApplied.map((promo) => {
                  const isDisneyPromo = promo.id === DISNEY_PROMO_ID;
                  return (
                    <>
                      {isDisneyPromo ? (
                        <CommonSection
                          leftValueText={promo?.description}
                          rightValueText={`-$${parseFloat(promo?.amountOff).toFixed(2)}`}
                          id="Promo-Offer"
                          subTitle={disneyPromoHelperText}
                          promoDiscount
                        />
                      ) : null}
                    </>
                  );
                })}
            </>
          );
        })}

      {isWhwAddon &&
        whwDueMontly?.map((item) => (
          <CommonSection
            id="whw Info"
            leftValueText={item?.featureDesc}
            rightValueText={
              <>
                {/* {parseFloat(item?.actualAmount)?.toFixed(2) !== parseFloat(item?.featurePrice)?.toFixed(2) && (
                  // <span>
                  //   <span className="actualPriceStrikeThrough">${parseFloat(item?.perkOriginalPrice)?.toFixed(2)}</span>&nbsp;
                  // </span>
                )} */}
                ${parseFloat('5.00')?.toFixed(2)}
              </>
            }
            className="normalStyle"
            subTitle=""
          />
        ))}

      {dueMonthlyTaxes !== null && dueMonthlyTaxes !== undefined && dueMonthlyTaxes !== '' && (
        <Tax totalDueMonthlyTaxAmount={dueMonthlyTaxes} dueMonthlyList={dueMonthlyList} planInfo={planInfo} showMonthly />
      )}
      {enableSelfSetup() && getAPPID() === 'AAL' && (
        <div className="textAlignLeft pad15 onlyBottomPad">
          <Body size="small" color="#6F7171">
            {nbsDisclaimerMonthly}
          </Body>
        </div>
      )}
    </div>
  );
};

DueMonthly.propTypes = {
  dueMontTotalAAL: PropTypes.string,
  dueMontAmount: PropTypes.string,
  plansReferenceData: PropTypes.object,
  dueMonthlyList: PropTypes.string,
  dueMonthlyTaxes: PropTypes.number,
  dueMonthlyProd: PropTypes.object,
  planPerks: PropTypes.array,
  whwDueMontly: PropTypes.array,
  disneyPromoHelperText: PropTypes.string,
};
export default DueMonthly;
